import axios from 'axios';

const delivgateApi = axios.create({
  baseURL: process.env.REACT_APP_DELIVGATE_URL + '/api/',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${process.env.REACT_APP_DELIVGATE_API_KEY}`,
  },
  timeout: 10000,
});

export default delivgateApi;
